import Factory from "@/schemas/factory";

const schema = new Factory().hasId().make();

schema.prop("publicationId").setType(Number);
schema.prop("publisherId").setType(Number);

export default schema;
